import React, { useState, useEffect } from 'react';
import PricingPlans from '../pricingPlans/PricingPlans';
import axios from '../../utils/axiosInstance';
import CommonForm from '../../components/commonComponent/CommonForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import { useNavigate, useParams } from "react-router-dom";
import MapPickerModal from '../../components/commonComponent/MapPickerModal';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const Usercreate = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('basic');
  const navigate = useNavigate();
  const [mapVisible, setMapVisible] = useState(false);
  const [selectedBusinessIndex, setSelectedBusinessIndex] = useState(null);
  const [businessDropdowns, setBusinessDropdowns] = useState([{ states: [], cities: [] }]);
  const [formValues, setFormValues] = useState({
    businesses: [
      {
        _id: '',
        business_name: '',
        primary_business: false,
        business_established_date: '',
        business_type: '',
        business_category: '',
        business_sub_category: '',
        business_formation: '',
        //business_product_service: '',
        team_size: '',
        business_email: '',
        mobile: '',
        gst_number: '',
        website_url: '',
        business_description: '',
        logo: null,
        banner: null,
        gstImage: null,
        buildingno: '',
        buildingName: '',
        landmark: '',
        area: '',
        country: localStorage.getItem("defaultCountry"),
        state: localStorage.getItem("defaultState"),
        city: localStorage.getItem("defaultCity"),
        pincode: '',
        latitude: '',
        longitude: '',
        instagram: '',
        google_profile: '',
        youtube: '',
        linkedin: '',
        facebook: '',
        withCard: '',
      },
    ],
    profilepic: null,
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    password: '',
    mobileNumber: '',
    iso_code: 'IN',
    phone_code:'91',
    dob: '',
    anniversaryDate: '',
    joiningDate: '',
    bloodGroup: '',
    gender: 'Male',
    roleId: '',
    cluster: [],
    chapter: [],
    responsibilities: [],
    address: '',
    aadharCard: '',
    panCard: '',
    userType: 'Member',
    country: localStorage.getItem("defaultCountry"),
    state: localStorage.getItem("defaultState"),
    city: localStorage.getItem("defaultCity"),
    pincode: '',
    latitude: '',
    longitude: '',
    wifeName: '',
        roleId: '',
    children: [{ name: '', dob: '', gender: '' }],
    emergencyContactName: '',
    emergencyContactMobile: '',
    fees: '', // <-- add this line for fees field
    plan: '', // <-- add plan field
  });

  const [dropdowns, setDropdowns] = useState({
    roles: [], clusters: [], chapters: [], responsibilities: [],
    businessTypes: [], businessCategories: [], businessSubCategories: [], businessFormations: [], businessProductServices: [],
    countries: [], states: [], cities: [],
    businessStates: [], businessCities: [], bloodGroups: [],
    plans: [], // <-- add plans dropdown
  });

  const [rawCountriesData, setRawCountriesData] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [allProductServices, setAllProductServices] = useState([]);
  const [businessProductServicesOptions, setBusinessProductServicesOptions] = useState([[]]);

  // Load static dropdowns (roles, clusters, etc.) and countries
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [
          rolesRes, clustersRes, chaptersRes, responsibilitiesRes,
          businessTypesRes, businessCategoriesRes, businessSubCategoriesRes, businessFormationsRes,
          businessProductServicesRes, countryRes, stateRes, cityRes, bloodGroupsRes,
          plansRes, // <-- fetch plans
        ] = await Promise.all([
          axios.get('/admin/api/role'),
          axios.get('/admin/api/clusters/all'),
          axios.get('/admin/api/chapters/all'),
          axios.get('/admin/api/responsibility/all'),
          axios.get('/admin/api/businessType'),
          axios.get('/admin/api/businessCategory'),
          axios.get('/admin/api/businessSubCategory'),
          axios.get('/admin/api/businessFormation'),
          axios.get('/admin/api/productOrService'),
          axios.get('/admin/api/country'),
          axios.get('/admin/api/state'),
          axios.get('/admin/api/city'),
          axios.get('/api/blood-group'),
          axios.get('/api/plan'), // <-- fetch plans
        ]);
        console.log("countryRes",countryRes);
        const countries = countryRes.data?.countries || [];
        const states = stateRes.data?.states || [];
        const cities = cityRes.data?.cities || [];
        setRawCountriesData(countries);
        setDropdowns(prev => ({
          ...prev,
          businessTypes: businessTypesRes.data?.businessTypes?.map(bt => ({ value: bt._id, label: bt.name })) || [],
          businessCategories: businessCategoriesRes.data?.businessCategories?.map(bc => ({ value: bc._id, label: bc.name })) || [],
          // fixed typo: use _id (not _1d) so options have correct ids when editing/fetching user data
          businessSubCategories: businessSubCategoriesRes.data?.businessSubCategories?.map(bsc => ({ value: bsc._id, label: bsc.name, category: bsc.category })) || [],
          businessFormations: businessFormationsRes.data?.businessFormations?.map(bf => ({ value: bf._id, label: bf.name })) || [],
          businessProductServices: businessProductServicesRes.data?.productOrServices?.map(bps => ({ value: bps._id, label: bps.name })) || [],
          roles: rolesRes.data?.roles?.map(r => ({ value: r._id, label: r.name })) || [],
          clusters: clustersRes.data?.cluster?.map(c => ({ value: c._id, label: c.name })) || [],
          chapters: chaptersRes.data?.chapter?.map(ch => ({ value: ch._id, label: ch.name })) || [],
          responsibilities: responsibilitiesRes.data?.responsibility?.map(res => ({ value: res._id, label: res.name })) || [],
          countries: countries.map(c => ({ value: c._id, label: c.name })),
          states: states.map(s => ({ value: s._id, label: s.name })),
          cities: cities.map(c => ({ value: c._id, label: c.name })),
          bloodGroups: bloodGroupsRes.data?.bloodGroups?.map(bg => ({
            value: bg._id,
            label: bg.name
          })) || [],
          plans: plansRes.data?.plans?.map(plan => ({
            value: plan._id,
            label: plan.name
          })) || [], // <-- set plans
        }));
        setAllProductServices(businessProductServicesRes.data?.productOrServices || []);
      } catch (error) {
        toastError('Failed to load dropdown data');
      }
    };
    fetchDropdownData();
  }, []);

  const fetchStatesByCountry = async (countryId, isForBusiness = false) => {
    try {
      const response = await axios.get(`/admin/api/state?countryId=${countryId}`);
      const states = response.data?.states || [];
      if (isForBusiness) {
        setDropdowns(prev => ({
          ...prev,
          businessStates: states.map(s => ({ value: s._id, label: s.name })),
          businessCities: [],
        }));
      } else {
        setDropdowns(prev => ({
          ...prev,
          states: states.map(s => ({ value: s._id, label: s.name })),
          cities: [],
        }));
      }
      return states;
    } catch (error) {
      toastError('Failed to load states');
      return [];
    }
  };

  const fetchCitiesByState = async (stateId, isForBusiness = false) => {
    try {
      const response = await axios.get(`/admin/api/city?stateId=${stateId}`);
      const cities = response.data?.cities || [];
      if (isForBusiness) {
        setDropdowns(prev => ({
          ...prev,
          businessCities: cities.map(c => ({ value: c._id, label: c.name })),
        }));
      } else {
        setDropdowns(prev => ({
          ...prev,
          cities: cities.map(c => ({ value: c._id, label: c.name })),
        }));
      }
      return cities;
    } catch (error) {
      toastError('Failed to load cities');
      return [];
    }
  };

  useEffect(() => {
    // Only run on create (not edit)
    if (id) return;

    const defaultCountry = localStorage.getItem("defaultCountry");
    const defaultState = localStorage.getItem("defaultState");
    const defaultCity = localStorage.getItem("defaultCity");

    setFormValues(prev => ({
      ...prev,
      businesses: prev.businesses.map(business => ({
        ...business,
        country: defaultCountry || '',
        state: defaultState || '',
        city: defaultCity || '',
      })),
    }));

    if (defaultCountry) {
      fetchBusinessStatesByCountry(defaultCountry, 0);
      if (defaultState) {
        fetchBusinessCitiesByState(defaultState, 0);
      }
    }
  }, [id]);

  useEffect(() => {
    if (!id) return;
    const fetchUserAndDropdowns = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`/api/user/${id}`);
        const user = res.data.user;
        const purchasePlans = res.data.purchasePlans;
        if (!user) throw new Error('Member not found');

        const defaultCountry = localStorage.getItem("defaultCountry") || '';
        const defaultState = localStorage.getItem("defaultState") || '';
        const defaultCity = localStorage.getItem("defaultCity") || '';
        let countryId = user.country?._id || user.country || defaultCountry;
        let stateId = user.state?._id || user.state || defaultState;
        let cityId = user.city?._id || user.city || defaultCity;

        countryId = typeof countryId === 'object' ? countryId._id : countryId;
        stateId = typeof stateId === 'object' ? stateId._id : stateId;
        cityId = typeof cityId === 'object' ? cityId._id : cityId;

        await fetchStatesByCountry(countryId, false);
        await fetchCitiesByState(stateId, false);

        setFormValues(prev => ({
          ...prev,
          country: countryId || '',
          state: stateId || '',
          city: cityId || '',
          // Use the same field names as UserView.js for images
          profilepic: user.profilepic || user.profilePicture || '',
          aadharCard: user.aadharCard || user.adharCardImage || '',
          panCard: user.panCard || user.panCardImage || '',
          firstName: user.firstName || '',
          middleName: user.middleName || '',
          lastName: user.lastName || '',
          email: user.email || '',
          password: '',
          mobileNumber: user.mobileNumber || '',
          phone_code: user.phone_code || '',
          iso_code: user.iso_code || '',
          dob: user.dob ? user.dob.split('T')[0] : '',
          joiningDate: user.joiningDate? new Date(user.joiningDate).toISOString().split("T")[0]: "",
          anniversaryDate: user.anniversaryDate ? user.anniversaryDate.split('T')[0] : '',
          bloodGroup: user.bloodGroup?._id || user.bloodGroup || '',
          gender: user.gender || 'Male',
          // Single-select role: use first role's id (or empty string)
          roleId: (user.roles && user.roles.length > 0) ? (user.roles[0]._id || user.roles[0].id || (typeof user.roles[0] === 'string' ? user.roles[0] : '')) : '',
          cluster: user.cluster ? user.cluster.map(c => c._id) : [],
          chapter: user.chapter ? user.chapter[0]?._id : '',
          responsibilities: user.responsibilities ? user.responsibilities.map(r => r._id) : [],
          pincode: user.pincode || '',
          latitude: user.location?.coordinates ? user.location.coordinates[1] : (user.latitude || ''),
          longitude: user.location?.coordinates ? user.location.coordinates[0] : (user.longitude || ''),
          houseNo: user.houseNo || '',
          building: user.building || '',
          landmark: user.landmark || '',
          area: user.area || '',
          aadharCard: user.aadharCard || '',
          panCard: user.panCard || '',
          wifeName: user.wife ? user.wife.name : '',
          wifeDob: user.wife ? user.wife.dob.split('T')[0] : '',
          wife_contact: user.wife ? user.wife.mobileNumber : '',
          children: user.children && user.children.length
            ? user.children.map(child => ({
                name: child.name || child.childName || '',
                dob: child.dob ? child.dob.split('T')[0] : child.childdob || '',
                gender: child.gender || child.childgender || '',
              }))
            : [{ name: '', dob: '', gender: '' }],
          emergencyContactName: user.emergencyContactName || '',
          emergencyContactMobile: user.emergencyContactMobile || '',
          plan: purchasePlans && Array.isArray(purchasePlans) && purchasePlans[0] && Array.isArray(purchasePlans[0].plan) && purchasePlans[0].plan[0] ? purchasePlans[0].plan[0]._id : '',
          businesses: user.business && user.business.length > 0
            ? user.business.map(biz => ({
                _id: biz._id || biz.id || '',
                business_name: biz.name || biz.businessName || '',
                primary_business: biz.primaryBusiness || false,
                business_established_date: biz.establishedDate ? biz.establishedDate.split('T')[0] : (biz.businessEstablishedDate ? biz.businessEstablishedDate.split('T')[0] : ''),
                business_type: biz.type ? biz.type._id : (biz.businessType ? biz.businessType._id : ''),
                business_category: biz.category ? biz.category._id : (biz.businessCategory ? biz.businessCategory._id : ''),
                business_sub_category: Array.isArray(biz.subCategory) ? biz.subCategory.map(sc => sc._id): (biz.subCategory?._id ? [biz.subCategory._id] : []),
                business_formation: biz.formation ? biz.formation._id : (biz.businessFormation ? biz.businessFormation._id : ''),
                //business_product_service: biz.productsOrServices ? biz.productsOrServices._id : '',
                team_size: biz.teamSize || '',
                business_email: biz.email || biz.businessEmail || '',
                mobile: biz.number || biz.businessMobileNumber || '',
                gst_number: biz.gstNumber || '',
                website_url: biz.websiteURL || '',
                business_description: biz.description || biz.businessDescription || '',
                // keep image fields as returned from server (usually string URLs or stored filenames)
                logo: biz.logo || biz.logoImage || '',
                banner: biz.banner || biz.bannerImage || '',
                gstImage: biz.gstImage || biz.certificateImage || '',
                buildingno: biz.buildingno || '',
                buildingName: biz.buildingName || '',
                landmark: biz.landmark || '',
                area: biz.area || '',
                country: biz.country ? biz.country._id : (localStorage.getItem("defaultCountry") || ''),
                state: biz.state ? biz.state._id : (localStorage.getItem("defaultState") || ''),
                city: biz.city ? biz.city._id : (localStorage.getItem("defaultCity") || ''),
                pincode: biz.pincode || '',
                latitude: biz.location?.coordinates ? biz.location.coordinates[1] : '',
                longitude: biz.location?.coordinates ? biz.location.coordinates[0] : '',
                instagram: biz.socialMedia?.instagram || '',
                google_profile: biz.socialMedia?.googleProfile || '',
                youtube: biz.socialMedia?.youtube || '',
                linkedin: biz.socialMedia?.linkedin || '',
                facebook: biz.socialMedia?.facebook || '',
                withCard: biz.socialMedia?.withCard || '',
              }))
            : prev.businesses,
        }));

        if (user.business && user.business.length > 0) {
          const dropdownArr = [];
          for (let i = 0; i < user.business.length; i++) {
            dropdownArr.push({ states: [], cities: [] });
          }
          setBusinessDropdowns(dropdownArr);

          for (let i = 0; i < user.business.length; i++) {
            const biz = user.business[i];
            const countryId = biz.country?._id || biz.country || defaultCountry;
            const stateId = biz.state?._id || biz.state || defaultState;

            if (countryId) {
              await fetchBusinessStatesByCountry(countryId, i);
              if (stateId) {
                await fetchBusinessCitiesByState(stateId, i);
              }
            }
          }
        }
      } catch (error) {
        toastError('Failed to fetch user data');
        navigate('/user');
      } finally {
        setLoading(false);
      }
    };
    fetchUserAndDropdowns();
  }, [id, navigate]);

  const fetchBusinessStatesByCountry = async (countryId, index) => {
    try {
      const response = await axios.get(`/admin/api/state?countryId=${countryId}`);
      const states = response.data?.states || [];
      setBusinessDropdowns(prev => {
        const updated = [...prev];
        updated[index] = { ...updated[index], states: states.map(s => ({ value: s._id, label: s.name })), cities: [] };
        return updated;
      });
    } catch (error) {
      toastError('Failed to load states');
    }
  };

  const fetchBusinessCitiesByState = async (stateId, index) => {
    try {
      const response = await axios.get(`/admin/api/city?stateId=${stateId}`);
      const cities = response.data?.cities || [];
      setBusinessDropdowns(prev => {
        const updated = [...prev];
        updated[index] = { ...updated[index], cities: cities.map(c => ({ value: c._id, label: c.name })) };
        return updated;
      });
    } catch (error) {
      toastError('Failed to load cities');
    }
  };

  const fetchProductServicesBySubCategory = async (subCategoryId, businessIndex) => {
    if (!subCategoryId) {
      setBusinessProductServicesOptions(prev => {
        const updated = [...prev];
        updated[businessIndex] = [];
        return updated;
      });
      return;
    }
    try {
      const res = await axios.get(`/admin/api/productOrService?subCategoryId=${subCategoryId}`);
      const options = (res.data.productOrServices || []).map(ps => ({ value: ps._id, label: ps.name }));
      setBusinessProductServicesOptions(prev => {
        const updated = [...prev];
        updated[businessIndex] = options;
        return updated;
      });
    } catch (err) {
      setBusinessProductServicesOptions(prev => {
        const updated = [...prev];
        updated[businessIndex] = [];
        return updated;
      });
    }
  };

  const getProductServicesBySubCategory = (selectedSubCategoryIds) => {
    if (!selectedSubCategoryIds || selectedSubCategoryIds.length === 0) return [];
    return allProductServices
      .filter(ps =>
        ps.subCategory && ps.subCategory.some(sub =>
          Array.isArray(selectedSubCategoryIds)
            ? selectedSubCategoryIds.includes(sub._id)
            : sub._id === selectedSubCategoryIds
        )
      )
      .map(ps => ({ value: ps._id, label: ps.name }));
  };

  const handleBusinessAddressChange = (fieldName, value, index) => {
    if (fieldName === 'country') {
      fetchBusinessStatesByCountry(value, index);
      setFormValues(prev => {
        const updatedBusinesses = [...prev.businesses];
        updatedBusinesses[index].state = '';
        updatedBusinesses[index].city = '';
        return { ...prev, businesses: updatedBusinesses };
      });
    }
    if (fieldName === 'state') {
      fetchBusinessCitiesByState(value, index);
      setFormValues(prev => {
        const updatedBusinesses = [...prev.businesses];
        updatedBusinesses[index].city = '';
        return { ...prev, businesses: updatedBusinesses };
      });
    }
  };

  const handleAddBusiness = async () => {
    const defaultCountry = localStorage.getItem("defaultCountry");
    const defaultState = localStorage.getItem("defaultState");
    const defaultCity = localStorage.getItem("defaultCity");

    setFormValues(prev => ({
      ...prev,
      businesses: [
        ...prev.businesses,
        {
          _id: '',
          business_name: '',
          primary_business: false,
          business_established_date: '',
          business_type: '',
          business_category: '',
          business_sub_category: '',
          business_formation: '',
          //business_product_service: '',
          team_size: '',
          business_email: '',
          mobile: '',
          gst_number: '',
          website_url: '',
          business_description: '',
          logo: null,
          banner: null,
          gstImage: null,
          buildingno: '',
          buildingName: '',
          landmark: '',
          area: '',
          country: defaultCountry || '',
          state: defaultState || '',
          city: defaultCity || '',
          pincode: '',
          latitude: '',
          longitude: '',
          instagram: '',
          google_profile: '',
          youtube: '',
          linkedin: '',
          facebook: '',
          withCard: '',
        },
      ],
    }));
    setBusinessDropdowns(prev => ([...prev, { states: [], cities: [] }]));
    const newIndex = formValues.businesses.length;
    if (defaultCountry) {
      await fetchBusinessStatesByCountry(defaultCountry, newIndex);
      if (defaultState) {
        await fetchBusinessCitiesByState(defaultState, newIndex);
      }
    }
  };

  const handleRemoveBusiness = (index) => {
    setFormValues(prev => {
      const updated = [...prev.businesses];
      updated.splice(index, 1);
      return { ...prev, businesses: updated };
    });
    setBusinessDropdowns(prev => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  };
  const isEdit = !!id;
  const isPlanJoiningDateReadOnly = isEdit && !(formValues.chapter && formValues.chapter !== '');
  const isPlanEditable = Boolean(formValues.chapter && formValues.chapter !== '');

  const handleBasicChange = async (updated) => {
    let changed = false;
    // Detect chapter change in edit or create mode
    if (updated.chapter && updated.chapter !== formValues.chapter) {
      setFormValues(prev => ({
        ...prev,
        ...updated,
        plan: '', // Blank the plan field on chapter change (force new selection)
        joiningDate: new Date().toISOString().split('T')[0], // Set joining date to today
        ...(isEdit ? { userType: 'Member' } : {}), // Set userType to 'Member' if editing
      }));
      changed = true;
    }
    if (updated.country && updated.country !== formValues.country) {
      await fetchStatesByCountry(updated.country, false);
      setFormValues(prev => ({
        ...prev,
        country: updated.country,
        state: '',
        city: '',
      }));
      changed = true;
    }
    if (updated.state && updated.state !== formValues.state) {
      await fetchCitiesByState(updated.state, false);
      setFormValues(prev => ({
        ...prev,
        state: updated.state,
        city: '',
      }));
      changed = true;
    }
    if (!changed) {
      setFormValues(prev => ({ ...prev, ...updated }));
    }
  };

  const handleBusinessCategoryChange = async (categoryId, businessIndex) => {
    setFormValues(prev => {
      const updatedBusinesses = [...prev.businesses];
      updatedBusinesses[businessIndex].business_category = categoryId;
      updatedBusinesses[businessIndex].business_sub_category = [];
      return { ...prev, businesses: updatedBusinesses };
    });
    if (categoryId) {
      try {
        const response = await axios.get(`/admin/api/businessSubCategory?categoryId=${categoryId}`);
        setDropdowns(prev => ({
          ...prev,
          businessSubCategories: response.data?.businessSubCategories?.map(sc => ({
            value: sc._id,
            label: sc.name,
            category: sc.category,
          })) || [],
        }));
      } catch (err) {
        setDropdowns(prev => ({ ...prev, businessSubCategories: [] }));
      }
    } else {
      setDropdowns(prev => ({ ...prev, businessSubCategories: [] }));
    }
  };

  const handleBusinessSubCategoryChange = (subCategoryIds, businessIndex) => {
    setFormValues(prev => {
      const updatedBusinesses = [...prev.businesses];
      updatedBusinesses[businessIndex].business_sub_category = subCategoryIds;
      updatedBusinesses[businessIndex].business_product_service = '';
      return { ...prev, businesses: updatedBusinesses };
    });
    const options = getProductServicesBySubCategory(subCategoryIds);
    setBusinessProductServicesOptions(prev => {
      const updated = [...prev];
      updated[businessIndex] = options;
      return updated;
    });
  };

  const handleSubmit = async () => {
    const isEdit = !!id;
    const validationRules = {
      email: { required: true },
      firstName: { required: true },
      lastName: { required: true },
      middleName: { required: true },
      mobileNumber: { required: true, mobile: true },
      mobile: { mobile: true },
      emergencyContactMobile: { mobile: true },
      gst_number: { uppercase: true },
      ...(formValues.chapter && formValues.chapter !== ''
        ? {
            plan: { required: true }, // Always required if chapter selected or changed
            joiningDate: { required: true },
          }
        : {}),
      ...(formValues.address && formValues.address.trim() !== ''
        ? {
            country: { required: true },
            state: { required: true },
            city: { required: true },
          }
        : {}),
    };

    const validationErrors = validateForm(formValues, validationRules);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      const errorFields = Object.keys(validationErrors);
      if (errorFields.some(f => ['firstName', 'middleName', 'lastName', 'email', 'mobileNumber', 'dob', 'gender', 'bloodGroup', 'password', 'address', 'cluster', 'chapter', 'responsibilities', 'state', 'city', 'country'].includes(f))) {
        setActiveTab('basic');
      } else if (errorFields.some(f => ['wifeName', 'wifeDob', 'wife_contact', 'emergencyContactName', 'emergencyContactMobile', 'children'].includes(f))) {
        setActiveTab('family');
      } else if (errorFields.some(f => ['gst_number', 'business_name', 'mobile', 'business_email', 'latitude', 'longitude'].includes(f))) {
        setActiveTab('business');
      }
      return;
    }

    try {
      // include _id and existing image string refs in business JSON
      const businessData = Array.isArray(formValues.businesses)
        ? formValues.businesses
            .filter((biz) => biz.business_name && biz.business_name.trim() !== '')
            .map((biz) => ({
              _id: biz._id || biz.id || '',
              name: biz.business_name || '',
              primaryBusiness: biz.primary_business || false,
              establishedDate: biz.business_established_date || '',
              type: Array.isArray(biz.business_type) ? biz.business_type.join(',') : biz.business_type || '',
              category: Array.isArray(biz.business_category) ? biz.business_category.join(',') : biz.business_category || '',
              subCategory: Array.isArray(biz.business_sub_category) ? biz.business_sub_category.join(',') : biz.business_sub_category || '',
              formation: Array.isArray(biz.business_formation) ? biz.business_formation.join(',') : biz.business_formation || '',
              teamSize: biz.team_size || '',
              email: biz.business_email?.trim() || '',
              number: biz.mobile || '',
              gstNumber: biz.gst_number || '',
              websiteURL: biz.website_url || '',
              description: biz.business_description || '',
              socialMedia: {
                instagram: biz.instagram || '',
                googleProfile: biz.google_profile || '',
                youtube: biz.youtube || '',
                linkedin: biz.linkedin || '',
                facebook: biz.facebook || '',
                withCard: biz.withCard || '',
              },
              buildingno: biz.buildingno ||'' ,
              buildingName: biz.buildingName || '',
              landmark: biz.landmark ||'',
              area:biz.area ||'',
              pincode:biz.pincode ||'',
              country: biz.country || '',
              state: biz.state || '',
              city: biz.city || '',
              latitude:  biz.latitude || '',
              longitude: biz.longitude || '',
              // include string refs so backend can preserve when no new file is uploaded
              logo: typeof biz.logo === 'string' ? biz.logo : '',
              banner: typeof biz.banner === 'string' ? biz.banner : '',
              gstImage: typeof biz.gstImage === 'string' ? biz.gstImage : '',
            }))
        : [];

      const formData = new FormData();
      // ensure mobile, phone code and iso are sent in expected fields
      // we'll build a final values object to use when appending
      const finalValues = { ...formValues };
      formData.append('roleId', Array.isArray(finalValues.roleId) ? finalValues.roleId.join(',') : finalValues.roleId || '');
      formData.append('cluster', Array.isArray(finalValues.cluster) ? finalValues.cluster.join(',') : finalValues.cluster || '');
      formData.append('chapter', Array.isArray(finalValues.chapter) ? finalValues.chapter.join(',') : finalValues.chapter || '');
      formData.append('responsibilities', Array.isArray(finalValues.responsibilities) ? finalValues.responsibilities.join(',') : finalValues.responsibilities || '');

      formData.append('wife', finalValues.wifeName
        ? JSON.stringify({
            name: formValues.wifeName || '',
            dob: formValues.wifeDob || '',
            mobileNumber: formValues.wife_contact || '',
          })
        : '');

      const validChildren = (finalValues.children || []).filter(
        (child) =>
          (child.name && child.name.trim() !== '') ||
          (child.dob && child.dob.trim() !== '') ||
          (child.gender && child.gender.trim() !== '')
      );
      formData.append('children', validChildren.length > 0
        ? JSON.stringify(validChildren.map((child) => ({
            name: child.name || '',
            dob: child.dob || '',
            gender: child.gender || '',
          })))
        : '');

      // Append business JSON which contains _id for backend to update existing businesses and image references
      formData.append('business', JSON.stringify(businessData));

      // Append files for businesses and include the business _id for each index if present
      formValues.businesses.forEach((business, index) => {
        const businessId = business._id || business.id || business.businessId || '';
        if (businessId) {
          formData.append(`businesses[${index}][_id]`, businessId);
        }

        // Append logo only if user selected a new File. Existing string refs are included
        // in the `business` JSON already (so avoid appending them as file fields).
        if (business.logo instanceof File) {
          formData.append(`businesses[${index}][logo]`, business.logo);
        }

        // banner
        if (business.banner instanceof File) {
          formData.append(`businesses[${index}][banner]`, business.banner);
        }

        // gstImage / certificate
        if (business.gstImage instanceof File) {
          formData.append(`businesses[${index}][gstImage]`, business.gstImage);
        }
      });

      // Ensure email is lowercase before appending
      formData.append('email', (formValues.email || '').toLowerCase());

      for (const key in finalValues) {
        if (
          ['roleId', 'cluster', 'chapter', 'responsibilities', 'wifeName', 'wifeDob', 'wife_contact', 'children', 'businesses', 'email'].includes(key)
        ) continue;
        const value = finalValues[key];
        if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === 'object' && value !== null) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value ?? '');
        }
      }
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      if (isEdit) {
        const response = await axios.put(`/api/user/new/${id}`, formData, config);
        const data = response.data;
        if (data && typeof data === 'object' && 'Status' in data) {
          if (data.Status === 1) {
            toastSuccess(data.Message || 'User updated successfully!');
            navigate('/user');
          } else {
            let msg = '';
            if (Array.isArray(data.Message)) {
              msg = data.Message.join(', ');
            } else {
              msg = data.Message || 'Update failed';
            }
            toastError(msg);
          }
        } else {
          toastSuccess('User updated successfully!');
          navigate('/user');
        }
      } else {
        const response = await axios.post('/api/user/create', formData, config);
        const data = response.data;
        if (data && typeof data === 'object' && 'Status' in data) {
          if (data.Status === 1) {
            toastSuccess(data.Message || 'User created successfully!');
            navigate('/user');
          } else {
            let msg = '';
            if (Array.isArray(data.Message)) {
              msg = data.Message.join(', ');
            } else {
              msg = data.Message || 'Creation failed';
            }
            toastError(msg);
          }
        } else {
          toastSuccess('User created successfully!');
          navigate('/user');
        }
      }
    } catch (error) {
      let message = 'Failed to save User';

      if (error.response) {
        const data = error.response.data;
        if (typeof data === 'object' && data !== null && data.Message) {
          if (Array.isArray(data.Message)) {
            message = data.Message.join(', ');
          } else {
            message = data.Message;
          }
        } else if (typeof data === 'string') {
          message = data;
        } else if (Array.isArray(data.errors)) {
          message = data.errors.join(', ');
        } else if (data.errors) {
          message = Object.values(data.errors).flat().join(', ');
        } else if (data.error) {
          message = data.error;
        }
      } else if (error.request) {
        message = 'No response from server. Please try again.';
      } else {
        message = error.message;
      }

      toastError(message);
    }
  };

  const handleCancel = () => {
    setFormValues({
      businesses: [
        {
          _id: '',
          business_name: '',
          primary_business: false,
          business_established_date: '',
          business_type: '',
          business_category: '',
          business_sub_category: '',
          business_formation: '',
          team_size: '',
          business_email: '',
          mobile: '',
          gst_number: '',
          website_url: '',
          business_description: '',
          logo: null,
          banner: null,
          gstImage: null,
          buildingno: '',
          buildingName: '',
          landmark: '',
          area: '',
          country: '',
          state: '',
          city: '',
          pincode: '',
          latitude: '',
          longitude: '',
          instagram: '',
          google_profile: '',
          youtube: '',
          linkedin: '',
          facebook: '',
          withCard: '',
        },
      ],
      profilepic: null,
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      password: '',
      mobileNumber: '',
      phone_code: '91',
      iso_code: 'IN',
      dob: '',
      anniversaryDate: '',
      joiningDate: '',
      bloodGroup: '',
      gender: 'Male',
      roleId: '',
      cluster: [],
      chapter: [],
      responsibilities: [],
      country: '',
      state: '',
      city: '',
      pincode: '',
      latitude: '',
      longitude: '',
      houseNo: '',
      building: '',
      landmark: '',
      area: '',
      aadharCard: '',
      panCard: '',
      wifeName: '',
      wifeDob: '',
      wife_contact: '',
      children: [{ name: '', dob: '', gender: '' }],
      emergencyContactName: '',
      emergencyContactMobile: '',
      plan: '',
    });
    setErrors({});
    setDropdowns(prev => ({
      ...prev,
      states: [],
      cities: [],
      businessStates: [],
      businessCities: [],
    }));
  };

  const tabs = [
    { id: 'basic', label: 'Basic Info' },
    { id: 'family', label: 'Family Info' },
    { id: 'business', label: 'Business Info' },
  ];
  
  const fieldSets = {
    basic: [
      {
        section: 'Profile',
        fields: [
          { name: 'profilepic', label: 'Profile Pic', placeholder: 'Profile Pic', type: 'file' },
        ],
      },
      {
        section: 'Personal Details',
        fields: [
          { name: 'firstName', label: 'First Name', placeholder: 'First Name', type: 'text', required: true },
          { name: 'middleName', label: 'Middle Name', placeholder: 'Middle Name', type: 'text', required: true },
          { name: 'lastName', label: 'Last Name', placeholder: 'Last Name', type: 'text', required: true },
          {
            name: 'mobileNumber',
            label: 'Mobile Number',
            customComponent: ({ formValues, setFormValues }) => (
              <PhoneInput
                country="in"
                enableSearch={false}
                disableDropdown={true}   
                inputClass="form-control"
                containerClass="w-100"
                value={`${formValues.phone_code || ''}${formValues.mobileNumber || ''}`}
                inputProps={{
                  readOnly: true,    
                  tabIndex: -1,
                }}
                onChange={(value, country) => {
                  const dialCode = country.dialCode || '';
                  const mobile = value.startsWith(dialCode)
                    ? value.slice(dialCode.length)
                    : value;

                  setFormValues(prev => ({
                    ...prev,
                    iso_code: country.countryCode?.toUpperCase() || 'IN',
                    phone_code: dialCode,
                    mobileNumber: mobile
                  }));
                }}
              />
            )
          },
          { name: 'dob', label: 'Birthdate', placeholder: 'Birthdate', type: 'date' },
          { name: 'anniversaryDate', label: 'Anniversary Date', placeholder: 'Anniversary Date', type: 'date' },
          {
            name: 'bloodGroup',
            label: 'Blood Group',
            placeholder: 'Select Blood Group',
            type: 'select',
            options: dropdowns.bloodGroups,
          },
          {
            name: 'gender',
            label: 'Gender',
            placeholder: 'Select Gender',
            type: 'radio',
            options: [
              { value: 'Male', label: 'Male' },
              { value: 'Female', label: 'Female' },
            ],
          },
        ],
      },
      {
        section: 'Membership',
        fields: [
          // { name: 'cluster', label: 'Cluster', placeholder: 'Cluster', type: 'select', isMulti: true, options: dropdowns.clusters },
          { name: 'chapter', label: 'Chapter', placeholder: 'Chapter', type: 'select', options: dropdowns.chapters },
          { name: 'roleId', label: 'Role', placeholder: 'Role', type: 'select', options: dropdowns.roles },
          // { name: 'responsibilities', label: 'Responsibilities', placeholder: 'Responsibilities', type: 'select', isMulti: true, options: dropdowns.responsibilities },
        ],
      },
      {
        section: 'Address',
        fields: [
          { name: 'houseNo', label: 'House No', placeholder: 'House No', type: 'text'},
          { name: 'building', label: 'building/Socity Name', placeholder: 'building/Socity Name', type: 'text'},
          { name: 'landmark', label: 'Landmark ', placeholder: 'Landmark ', type: 'text'},
          { name: 'area', label: 'Area', placeholder: 'Area', type: 'text'},
          {
            name: 'country',
            label: 'Country',
            placeholder: 'Select Country',
            type: 'select',
            options: dropdowns.countries,
          },
          {
            name: 'state',
            label: 'State',
            placeholder: 'Select State',
            type: 'select',
            options: dropdowns.states,
          },
          {
            name: 'city',
            label: 'City',
            placeholder: 'Select City',
            type: 'select',
            options: dropdowns.cities,
          },
          { name: 'pincode', label: 'Pincode', type: 'text' },
          { name: 'basicLocation', label: 'Location (GPS)', placeholder: 'Click to select location', type: 'basicLocation' },
        ],
      },
      {
        section: 'Documents',
        fields: [
          { name: 'panCard', label: 'PAN Card', placeholder: 'PAN Card', type: 'file' },
          { name: 'aadharCard', label: 'Aadhar Card', placeholder: 'Aadhar Card', type: 'file' },
        ],
      },
      {
        section: 'Login',
        fields: [
          {
            name: 'email',
            label: 'Email ID',
            placeholder: 'Email ID',
            type: 'email',
            readOnly: isEdit,
            required: true,
          },
          {
            name: 'plan',
            label: 'Membership Plan',
            placeholder: 'Select Plan',
            type: 'select',
            options: dropdowns.plans,
            required: isPlanEditable, // required only when chapter selected
            readOnly: !isPlanEditable, // editable only if chapter selected
          },
          {
            name: 'joiningDate',
            label: 'Joining Date',
            placeholder: 'Joining Date',
            type: 'date',
            required: Boolean(formValues.chapter && formValues.chapter !== ''), // required when chapter selected
            readOnly: isPlanJoiningDateReadOnly,
          },
        ],
      },
    ],
    business: [
      {
        section: 'Business Details',
        fields: [
          {
            name: 'businesses',
            type: 'group',
            fields: [
              { name: 'business_name', label: 'Company Name', placeholder: 'Company Name', type: 'text' },
              { name: 'primary_business', label: 'Primary Business', placeholder: 'Primary Business', type: 'checkbox' },
              { name: 'business_established_date', label: 'Business Established Date', placeholder: 'Business Established Date', type: 'date' },
              {
                name: 'business_type',
                label: 'Business Type',
                placeholder: 'Select Business Type',
                type: 'select',
                options: dropdowns.businessTypes,
              },
              {
                name: 'business_category',
                label: 'Business Category',
                placeholder: 'Select Business Category',
                type: 'select',
                options: dropdowns.businessCategories,
              },
              {
                name: 'business_sub_category',
                label: 'Business Sub Category',
                placeholder: 'Select Business Sub Category',
                type: 'select',
                options: dropdowns.businessSubCategories,
                isMulti: true,
              },
              {
                name: 'business_formation',
                label: 'Business Formation',
                placeholder: 'Select Business Formation',
                type: 'select',
                options: dropdowns.businessFormations,
              },
              { name: 'team_size', label: 'Team Size', placeholder: 'Team Size', type: 'number' },
              { name: 'business_email', label: 'Business Email', placeholder: 'Business Email ID', type: 'email' },
              { name: 'mobile', label: 'Contact Number', placeholder: 'Contact Number', type: 'number' },
              { name: 'gst_number', label: 'GST Number', placeholder: 'GST Number', type: 'text' },
              { name: 'website_url', label: 'Website URL', placeholder: 'Website URL', type: 'text' },
              { name: 'business_description', label: 'Business Description', placeholder: 'Business Description', type: 'textarea', rows: 2 },
              { name: 'logo', label: 'Upload Logo', placeholder: 'Upload Logo', type: 'file' },
              { name: 'banner', label: 'Upload Banner', placeholder: 'Upload Banner', type: 'file' },
              { name: 'gstImage', label: 'Upload GST Certificate', placeholder: 'Upload GST Certificate', type: 'file' },
              { name: 'buildingno', label: 'Building no/ Shade no / office no', placeholder: 'Building no/ Shade no / office no', type: 'text'},
              { name: 'buildingName', label: 'Building name', placeholder: 'Building name', type: 'text'},
              { name: 'landmark', label: 'Landmark ', placeholder: 'Landmark ', type: 'text'},
              { name: 'area', label: 'Area', placeholder: 'Area', type: 'text'},
              {
                name: 'country',
                label: 'Country',
                placeholder: 'Select Country',
                type: 'select',
                options: dropdowns.countries,
              },
              {
                name: 'state',
                label: 'State',
                placeholder: 'Select State',
                type: 'select',
                options: dropdowns.businessStates,
              },
              {
                name: 'city',
                label: 'City',
                placeholder: 'Select City',
                type: 'select',
                options: dropdowns.businessCities,
              },
              { name: 'pincode', label: 'Pincode', placeholder: 'Pincode', type: 'text'},
              { name: 'latitude', label: 'Latitude', placeholder: 'Latitude', type: 'text' },
              { name: 'longitude', label: 'Longitude', placeholder: 'Longitude', type: 'text' },
              { name: 'instagram', label: 'Instagram', placeholder: 'Instagram', type: 'text' },
              { name: 'google_profile', label: 'Google Profile', placeholder: 'Google Profile', type: 'text' },
              { name: 'youtube', label: 'YouTube', placeholder: 'YouTube', type: 'text' },
              { name: 'linkedin', label: 'LinkedIn', placeholder: 'LinkedIn', type: 'text' },
              { name: 'facebook', label: 'Facebook', placeholder: 'Facebook', type: 'text' },
              { name: 'withCard', label: 'WithCard', placeholder: 'WithCard', type: 'text' },
            ],
          },
        ],
      },
    ],
    family: [
      { name: 'wifeName', label: 'Spouce Name', placeholder: 'Spouce Name', type: 'text' },
      { name: 'wifeDob', label: 'Spouce DOB', placeholder: 'Spouce DOB', type: 'date' },
      { name: 'wife_contact', label: 'Contact Number', placeholder: 'Contact Number', type: 'number' },
      { name: 'children', label: 'Children', placeholder: 'Children', type: 'group' },
      { name: 'emergencyContactName', label: 'Emergency Contact Name', placeholder: 'Emergency Contact Name', type: 'text' },
      { name: 'emergencyContactMobile', label: 'Emergency Contact Number', placeholder: 'Emergency Contact Number', type: 'number' },
    ],
  };

  if (loading) return <div>Loading user data...</div>;

  const renderTabContent = () => {
    switch (activeTab) {
      case 'basic':
        return (
          <CommonForm
            fieldSets={Array.isArray(fieldSets.basic) ? fieldSets.basic : []}
            values={formValues}
            errors={errors}
            onChange={handleBasicChange}
            dropdowns={dropdowns}
            loading={loading}
          />
        );
      case 'family':
        return (
          <CommonForm
            fieldSets={Array.isArray(fieldSets.family) ? fieldSets.family : []}
            values={formValues}
            errors={errors}
            onChange={setFormValues}
            dropdowns={dropdowns}
            loading={loading}
          />
        );
      case 'business':
        return (
          <CommonForm
            fieldSets={Array.isArray(fieldSets.business) ? fieldSets.business : []}
            values={formValues}
            errors={errors}
            onChange={setFormValues}
            dropdowns={dropdowns}
            loading={loading}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-3 text-dark border-bottom pb-2">{id ? 'Edit User & Business' : 'User & Business Registration'}</h4>
      <ul className="nav nav-tabs mb-4">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab.id}>
            <button
              className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
      <CommonForm
        title={tabs.find((tab) => tab.id === activeTab).label}
        fields={fieldSets[activeTab]}
        values={formValues}
        onBusinessAddressChange={handleBusinessAddressChange}
        businessDropdowns={businessDropdowns}
        onChange={handleBasicChange}
        onBusinessCategoryChange={handleBusinessCategoryChange}
        onBusinessSubCategoryChange={handleBusinessSubCategoryChange}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        errors={errors}
        requiredFields={['email', 'mobileNumber','firstName','middleName','lastName','gst_number',...(isEdit ? [] : ['password'])]}
        submitLabel={isEdit ? 'Update' : 'Save'}
        cancelLabel="Reset"
        countriesData={dropdowns.countries}
        rawCountriesData={rawCountriesData}
        openMapPicker={(target) => {
          if (target === 'basic') {
            setSelectedBusinessIndex(null);
          } else {
            setSelectedBusinessIndex(target);
          }
          setMapVisible(true);
        }}
        loading={loading} 
      />
      <MapPickerModal
        visible={mapVisible}
        onClose={() => setMapVisible(false)}
        onSave={(position) => {
          if (selectedBusinessIndex === null) {
            setFormValues({
              ...formValues,
              latitude: position.lat.toFixed(6),
              longitude: position.lng.toFixed(6),
            });
          } else {
            const updatedBusinesses = [...formValues.businesses];
            updatedBusinesses[selectedBusinessIndex].latitude = position.lat.toFixed(6);
            updatedBusinesses[selectedBusinessIndex].longitude = position.lng.toFixed(6);
            setFormValues({ ...formValues, businesses: updatedBusinesses });
          }
          setMapVisible(false);
        }}
        initialPosition={
          selectedBusinessIndex === null
            ? formValues.latitude && formValues.longitude
              ? [parseFloat(formValues.latitude), parseFloat(formValues.longitude)]
              : null
            : selectedBusinessIndex !== null &&
              formValues.businesses[selectedBusinessIndex]?.latitude &&
              formValues.businesses[selectedBusinessIndex]?.longitude
                ? [
                    parseFloat(formValues.businesses[selectedBusinessIndex].latitude),
                    parseFloat(formValues.businesses[selectedBusinessIndex].longitude),
                  ]
                : null
        }
      />
    </div>
  );
};

export default Usercreate;